import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const Calendar: FC<SvgIconProps> = (props) => (
  <SvgIcon {...props}>
    <path
      fillRule="evenodd"
      d="M8 3v2h8V3h2v2h1a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1V3h2zM6 19V9h12v10H6z"
      clipRule="evenodd"
    />
  </SvgIcon>
)
